/*
  BEELTRA V1 -- side drawer: solo el gatillo de "Hablar con Lucy &
  Jorge" (abre el FAB/widget YA existente, no crea un chat nuevo). La
  mecanica de abrir/cerrar el propio drawer es 100% de Dawn
  (global.js MenuDrawer) -- sin reimplementar nada de eso aqui.
*/
(function () {
  // BEELTRA: refleja el estado abierto/cerrado del drawer en <body> via
  // MutationObserver sobre el atributo "open" del <details> del drawer,
  // en vez de engancharse a un boton de cierre especifico -- asi cubre
  // TODOS los caminos de cierre de Dawn (X, overlay, Escape, navegacion,
  // boton Lucy) sin duplicar esa logica. Se usa solo para bajar el
  // z-index del lanzador de Lucy & Jorge mientras el drawer esta abierto
  // (ver assets/beeltra.css) -- no reemplaza el manejo real del drawer,
  // que sigue siendo 100% de Dawn (global.js MenuDrawer).
  var drawerDetails = document.querySelector('header-drawer details');
  if (drawerDetails) {
    var syncBodyState = function () {
      document.body.classList.toggle('beeltra-drawer-open', drawerDetails.hasAttribute('open'));
    };
    syncBodyState();
    new MutationObserver(syncBodyState).observe(drawerDetails, {
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  document.querySelectorAll('[data-beeltra-drawer-lucy]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      // BEELTRA: Dawn's MenuDrawer engancha onCloseButtonClick a
      // cualquier <button> dentro del drawer (excepto
      // .localization-selector) y llama closeSubmenu() sobre el
      // <details> mas cercano -- para este boton eso resuelve al
      // <details> PRINCIPAL del drawer, pero closeSubmenu() no
      // desbloquea el scroll del body (solo closeMenuDrawer() lo
      // hace). Se detiene esa propagacion y se dispara un cierre
      // real haciendo click en el summary (mismo camino que usa el
      // boton X), que si llama closeMenuDrawer() completo.
      e.stopPropagation();
      var details = btn.closest('details');
      var summary = details ? details.querySelector(':scope > summary') : null;
      if (summary) summary.click();

      var fab = document.getElementById('beeltraLucyFab');
      if (fab) {
        window.setTimeout(function () {
          fab.click();
        }, 320);
      }
    });
  });
})();
